/* eslint-disable react-hooks/exhaustive-deps */
import React, { Suspense, useEffect } from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { fetchUserLogin } from './admin/redux/auth/slice'
import { fetchUser } from './main/redux/auth/slice'

import '../src/index.css'

const AdminLogin = React.lazy(() => import('./admin/views/pages/login/Login'))
const CompanyLogin = React.lazy(() => import('./company/views/pages/login/Login'))
const DistributerLogin = React.lazy(() => import('./distributor/views/pages/login/Login'))

const TermsAndCondition = React.lazy(() =>
  import('./global/views/pages/termsCondition/TermsCondition'),
)
const PrivacyAndPolicy = React.lazy(() =>
  import('./global/views/pages/privacyPolicy/PrivacyPolicy'),
)

const Admin = React.lazy(() => import('./admin'))
const Main = React.lazy(() => import('./main'))

const Company = React.lazy(() => import('./company'))
const Distributer = React.lazy(() => import('./distributor'))

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

const App = () => {
  const dispatch = useDispatch()
  const { adminAuth } = useSelector((state) => state.adminAuthReducer)
  // const { companyAuth } = useSelector((state) => state.companyAuthReducer)
  // const { distributorAuth } = useSelector((state) => state.distributerAuthReducer)

  useEffect(() => {
    dispatch(fetchUserLogin())
    dispatch(fetchUser())
  }, []) 

  return (
    <Router>
      <Suspense fallback={loading}>
        <Routes>
          {adminAuth === false ? (
            <Route exact path="/grocery/admin/*" name="Admin Login" element={<AdminLogin />} />
          ) : (
            <Route exact path="/grocery/admin/*" name="Home" element={<Admin />} />
          )}
          {/* {companyAuth === false ? (
            <Route
              exact
              path="/grocery/company/*"
              name="Company Login"
              element={<CompanyLogin />}
            />
          ) : (
            <Route exact path="/grocery/company/*" name="Company Home" element={<Company />} />
          )}
          {distributorAuth === false ? (
            <Route
              exact
              path="/grocery/distributer/*"
              name="Distributer Login"
              element={<DistributerLogin />}
            />
          ) : (
            <Route
              exact
              path="/grocery/distributer/*"
              name="Distributer Home"
              element={<Distributer />}
            />
          )} */}

          <Route
            exact
            path="/terms-conditions"
            name="Terms And Conditions Page"
            element={<TermsAndCondition />}
          />
          <Route
            exact
            path="/privacy-policy"
            name="Privacy And Policy Page"
            element={<PrivacyAndPolicy />}
          />
          <Route path="*" name="Home" element={<Main />} />
        </Routes>
      </Suspense>
    </Router>
  )
}

export default App
